import { render, staticRenderFns } from "./ProgramsPartnerships.vue?vue&type=template&id=8894e6da&scoped=true&"
import script from "./ProgramsPartnerships.vue?vue&type=script&lang=js&"
export * from "./ProgramsPartnerships.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsPartnerships.vue?vue&type=style&index=0&id=8894e6da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8894e6da",
  null
  
)

export default component.exports